import {
  ACTION_ADD_SITES,
  ACTION_SET_CURRENT_SITE_ID,
} from '../actionTypes';


export const actionAddSites = sites => ({
  type: ACTION_ADD_SITES,
  payload: { sites },
});

export const actionSetCurrentSiteId = siteId => ({
  type: ACTION_SET_CURRENT_SITE_ID,
  payload: { siteId },
});
